module.exports = __webpack_public_path__ + "media/scholarship_winners/charles-b-289effc4.png";